// Live "Fuentes" (partners/sources) store. Seeded with the static fallback
// so the UI renders instantly; refreshed from /api/partners once per session
// and after any edit in the Fuentes page.
import { useEffect, useState } from "react";
import api from "./api";
import { PARTNER_OPTIONS } from "@/pages/builder/utils";

const toOption = (p) => ({
  value: p.key, label: p.label, hidden: !!p.hidden, isDefault: !!p.is_default,
  markup_pct: Number(p.markup_pct ?? 30), commission_pct: Number(p.commission_pct ?? 0),
  hint: `${p.commission_pct ?? 0}% comisión · markup ${p.markup_pct ?? 30}%`,
  sofi_partner: p.sofi_partner, sofi_source: p.sofi_source, builtin: !!p.builtin,
});

let state = {
  options: PARTNER_OPTIONS,
  defaultKey: "zicasso",
  canManage: false,
  sofiPartnerOptions: [],
  sofiSourceOptions: [],
  loaded: false,
};
let pending = null;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(state));

export function loadPartners(force = false) {
  if (pending && !force) return pending;
  pending = api.get("/partners").then(({ data }) => {
    state = {
      options: (data.partners || []).map(toOption),
      defaultKey: data.default_key || "zicasso",
      canManage: !!data.can_manage,
      sofiPartnerOptions: data.sofi_partner_options || [],
      sofiSourceOptions: data.sofi_source_options || [],
      loaded: true,
    };
    emit();
    return state;
  }).catch(() => state);
  return pending;
}

export const partnerOptions = () => state.options;
export const partnerDefaultKey = () => state.defaultKey;
export const partnerLabel = (key) => state.options.find((p) => p.value === key)?.label || key || "";
export const partnerDefaults = (key) => {
  const p = state.options.find((o) => o.value === key);
  return p ? { markup_pct: p.markup_pct, commission_pct: p.commission_pct } : null;
};

export function usePartners() {
  const [snap, setSnap] = useState(state);
  useEffect(() => {
    listeners.add(setSnap);
    loadPartners();
    return () => listeners.delete(setSnap);
  }, []);
  return {
    options: snap.options,
    visible: snap.options.filter((p) => !p.hidden),
    defaultKey: snap.defaultKey,
    canManage: snap.canManage,
    sofiPartnerOptions: snap.sofiPartnerOptions,
    sofiSourceOptions: snap.sofiSourceOptions,
    loaded: snap.loaded,
    label: partnerLabel,
    defaults: partnerDefaults,
    reload: () => loadPartners(true),
  };
}
